import { verifyArrayParameters } from 'helpers/genericHelper';
import { ApiResps, apiCall } from '~/providers';
import { MaintenanceFilters } from '../types';

export type MaintenanceSummary = ApiResps['/asset-management/get-overview-summary'];
export type MaintenanceAnalytics = ApiResps['/asset-management/get-overview-analytics'];
export type MaintenanceFilterOptions = ApiResps['/asset-management/get-filter-options'];

export async function getMaintenanceSummary(
  filters: MaintenanceFilters,
): Promise<MaintenanceSummary | undefined> {
  try {
    const response = await apiCall('/asset-management/get-overview-summary', {
      CLIENT_IDS: verifyArrayParameters(filters.clients),
      STATE_IDS: verifyArrayParameters(filters.states),
      CITY_IDS: verifyArrayParameters(filters.cities),
      INCLUDE_UNIT_STATUS: verifyArrayParameters(filters.unitStatuses),
      MACHINE_BRANDS: verifyArrayParameters(filters.brands),
      MACHINE_TYPES: verifyArrayParameters(filters.machineTypes),
      MACHINE_FLUID_TYPES: verifyArrayParameters(filters.fluids),
    });
    return response;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function getMaintenanceAnalytics(
  filters: MaintenanceFilters,
): Promise<MaintenanceAnalytics | undefined> {
  try {
    const response = await apiCall('/asset-management/get-overview-analytics', {
      CLIENT_IDS: verifyArrayParameters(filters.clients),
      STATE_IDS: verifyArrayParameters(filters.states),
      CITY_IDS: verifyArrayParameters(filters.cities),
      INCLUDE_UNIT_STATUS: verifyArrayParameters(filters.unitStatuses),
      MACHINE_BRANDS: verifyArrayParameters(filters.brands),
      MACHINE_TYPES: verifyArrayParameters(filters.machineTypes),
      MACHINE_FLUID_TYPES: verifyArrayParameters(filters.fluids),
    });
    return response;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function getMaintenanceFilterOptions(
  filters: MaintenanceFilters,
): Promise<MaintenanceFilterOptions | undefined> {
  try {
    const response = await apiCall('/asset-management/get-filter-options', {
      CLIENT_IDS: verifyArrayParameters(filters.clients),
      STATE_IDS: verifyArrayParameters(filters.states),
      CITY_IDS: verifyArrayParameters(filters.cities),
      INCLUDE_UNIT_STATUS: verifyArrayParameters(filters.unitStatuses),
      MACHINE_BRANDS: verifyArrayParameters(filters.brands),
      MACHINE_TYPES: verifyArrayParameters(filters.machineTypes),
      MACHINE_FLUID_TYPES: verifyArrayParameters(filters.fluids),
    });
    return response;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}
